import React, { useMemo } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

// 🔥 helper
const getCssVar = (variable: string) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
};

const StatusPieChart = ({ data }: any) => {
  // ✅ dynamic data mapping
  const chartData = useMemo(
    () => [
      {
        name: "Users",
        value: data?.users || 0,
        color: getCssVar("--primary-main"),
      },
      {
        name: "Bookings",
        value: data?.bookings || 0,
        color: getCssVar("--blue"),
      },
      {
        name: "In-Progress",
        value: data?.in_progress || 0,
        color: getCssVar("--warning"),
      },
      {
        name: "Completed",
        value: data?.completed || 0,
        color: getCssVar("--success"),
      },
    ],
    [data]
  );

  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey="value"
          innerRadius={60}
          outerRadius={90}
          paddingAngle={3}
        >
          {chartData.map((entry, index) => (
            <Cell key={index} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default StatusPieChart;